import { RouteHttpVerb } from "@devowl-wp/utils";
export const locationRestTcfDeclarationsGet = {
    path: "/tcf/declarations",
    method: RouteHttpVerb.GET
};
